const globalURL = "https://api.iolafashion.com";
const webPage = "https://iolafashion.com";
const fetchApiHeaders = {
    POST: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
    }
}

const firebaseConfig = {
    apiKey: "AIzaSyAjhsTo8h47tBFQn19RV9BHcM_WR4nECns",
    authDomain: "iolafashion.firebaseapp.com",
    projectId: "iolafashion",
    storageBucket: "iolafashion.appspot.com",
    messagingSenderId: "98808991879",
    appId: "1:98808991879:web:d0c78f6d9e046b1641a822",
    measurementId: "G-CYJTNBMHZX"
  };

export {
    globalURL,
    fetchApiHeaders,
    webPage,
    firebaseConfig
}